class TrackingState {
    constructor() {
        this.state = TrackingState.DefaultState;
        (Object.keys(this.state)).forEach(key => {
            if ((key in this) == false) {
                Object.defineProperty(this, key, {
                    get: () => {
                        return this.state[key];
                    },

                    set: (value) => {
                        return this.state[key] = value;
                    }
                })
            }
        })
    }
    get allowTracking() {
        let { state } = this;
        let allowTracking = state.allowTracking && ((state.started || state.ended) && state.seeking === false && state.buffering == false);
        return allowTracking;
    }

    set allowTracking(flag = true) {
        this.state.allowTracking = flag;
    }

    static get DefaultState() {
        return {
            allowTracking: true,
            ended: false,
            started: false,
            milestones: {
                "25": true,
                "50": true,
                "75": true,
                "100": true
            },
            configId: "",
            loadeddata: false,
            seeking: false,
            play: false,
            buffering: false,
            wasAutoplayed: false,
            isMuted: true,
            hasStartedPlaying: false
        }
    }
}

export { TrackingState }